import { azubiStatus } from '#components/m/Ausbildungsnachweis/AzubiStatusBadge'
import { differenceInCalendarMonths, differenceInCalendarWeeks } from 'date-fns'

export function calculateAzubiNachweisStatus(azubi) {
  switch (azubi.ausbildungsnachweisTyp) {
    case 'weekly':
      return calculateWeekly(azubi.ausbildungsstart, azubi.acceptedOrSubmittedNachweisCount)
    case 'weekly_with_qualification':
      return calculateWeekly(azubi.ausbildungsstart, azubi.acceptedOrSubmittedNachweisCount)
    case 'daily':
      return calculateWeekly(azubi.ausbildungsstart, azubi.acceptedOrSubmittedNachweisCount)
    case 'daily_with_qualification':
      return calculateWeekly(azubi.ausbildungsstart, azubi.acceptedOrSubmittedNachweisCount)
    case 'monthly':
      return calculateMonthly(azubi.ausbildungsstart, azubi.acceptedOrSubmittedNachweisCount)
    default:
      return {status: azubiStatus.good, numberOfMissingNachweise: 0}
  }
}

function calculateWeekly(start, numberOfSubmittedOrAcceptedNachweise) {
  const maxNumberOfSubmittableNachweise = getWeeklyMaxNumberOfSubmittableNachweise(start)
  const numberOfMissingNachweise = maxNumberOfSubmittableNachweise - numberOfSubmittedOrAcceptedNachweise
  return assignAzubiStatusWeekly(numberOfMissingNachweise >= 0 ? numberOfMissingNachweise : 0)
}

function calculateMonthly(start, numberOfSubmittedOrAcceptedNachweise) {
  const maxNumberOfSubmittableNachweise = getMonthlyMaxNumberOfSubmittableNachweise(start)
  const numberOfMissingNachweise = maxNumberOfSubmittableNachweise - numberOfSubmittedOrAcceptedNachweise
  return assignAzubiStatusMonthly(numberOfMissingNachweise)
}

function assignAzubiStatusMonthly(numberOfMissingNachweise) {
  if (numberOfMissingNachweise >= 0 && numberOfMissingNachweise < 2) {
    return {status: azubiStatus.good, numberOfMissingNachweise: numberOfMissingNachweise}
  }
  return {status: azubiStatus.critical, numberOfMissingNachweise: numberOfMissingNachweise}
}

function assignAzubiStatusWeekly(numberOfMissingNachweise) {
  if (numberOfMissingNachweise >= 0 && numberOfMissingNachweise <= 2) {
    return {status: azubiStatus.good, numberOfMissingNachweise: numberOfMissingNachweise}
  }
  if (numberOfMissingNachweise < 5) {
    return {status: azubiStatus.warning, numberOfMissingNachweise: numberOfMissingNachweise}
  }
  return {status: azubiStatus.critical, numberOfMissingNachweise: numberOfMissingNachweise}
}

const MONDAY = 1;

function getWeeklyMaxNumberOfSubmittableNachweise(startDate) {
  const today = Date.now()
  const start = new Date(startDate)
  const differenceInWeeks = differenceInCalendarWeeks(today, start, { weekStartsOn: MONDAY });

  return differenceInWeeks >= 0 ? differenceInWeeks : 0
}

function getMonthlyMaxNumberOfSubmittableNachweise(startDate) {
  const today = Date.now()
  const start = new Date(startDate)

  return Math.max(differenceInCalendarMonths(today, start), 0)
}
